import styled from 'styled-components';

export const PageFooter = styled.footer`
  padding: 40px;
`;
